import type { ReactNode } from 'react'

import Link from 'next/link'

import type { BreadcrumbRoutingLinkProps } from '@b-stock/fe-core/bstock-react'
import { Breadcrumbs as BstockBreadcrumbs } from '@b-stock/fe-core/bstock-react'

import LegacyBpLink from '@/buyer-portal/components/LegacyBpLink'

// define the Props
type BreadcrumbItem = {
  label: ReactNode
  url: string
  isCurrentPage?: boolean
  handleClick?: () => void
}

type BreadcrumbsProps = {
  items: BreadcrumbItem[]
  isThread?: boolean
  currentPageLabel?: ReactNode
}

/**
 * WARNING: Do not remove this component - when imported from bstock-next it works incorrectly.
 */

const RoutingLink = ({ item, className }: BreadcrumbRoutingLinkProps) => {
  const handleClick = (item as BreadcrumbItem).handleClick as
    | React.MouseEventHandler<HTMLAnchorElement>
    | undefined
  if (item.url === '/all-auctions') {
    // all-auctions is a special case, where it looked like a relative link
    // but in actuality it was linking to a different portal.
    // These are now in the same portal, so it can be a next/link... but
    // it is still a special case since everything else using this Breadcrumbs
    // component assumes it is supposed to be a LegacyBpLink
    return (
      <Link href={item.url} className={className} onClick={handleClick}>
        {item.label}
      </Link>
    )
  }
  return (
    <LegacyBpLink href={item.url} className={className} onClick={handleClick}>
      {item.label}
    </LegacyBpLink>
  )
}

export const Breadcrumbs = ({
  items,
  isThread,
  currentPageLabel,
}: BreadcrumbsProps) => {
  return (
    <BstockBreadcrumbs
      items={items}
      RoutingLink={RoutingLink}
      isThread={isThread}
      currentPageLabel={currentPageLabel}
    />
  )
}
